import React, { FC, Fragment } from 'react'

import { Form, Formik } from 'formik'
import AsideColumnCopy from '../create-product/AsideColumnCopy'
import MainColumnCopy from '../create-product/MainColumnCopy'
import { InitialValuesForCreateProduct } from 'src/interfaces/createProductInterface'
import MainColumn from '../create-product/FirstPhase'
import AsideColumn from '../create-product/SecondPhase'

const initialValues: InitialValuesForCreateProduct = {
  name: '',
  description: "",
  basePrice: '',
  image_set: [],
  options: [],
  varients_data: [],
  selectedStatus: 'DRAFT', // Dummy value
  scheduledDateTime: "2024-05-20T18:20", // Dummy value
  selectedOptions: [
    { value: 'Computers', label: 'Computers' }, // Dummy option
    { value: 'Headphones', label: 'Headphones' }, // Dummy option

  ],
  selectedValues: [
    { value: 'Computers', label: 'Computers' }, // Dummy option
    { value: 'Headphones', label: 'Headphones' }, // Dummy option
  ], // Empty array

  // Fields with dummy data based on add_product_meta_keywords
  inputValue: '', // User will input this
  productTemplate: '', // Consider using a default value or selection
  selectedTagValues: [
    { value: 'Computers', label: 'Computers' }, // Dummy option
    { value: 'Headphones', label: 'Headphones' }, // Dummy option
  ], // Empty array

  product_name: 'Test Product', // User will input this
  barcode: '3333', // User will input this
  shelfQuantity: '1', // User will input this
  warehouseQuantity: '2', // User will input this
  allowBackorders: false, // Set initial backorder state (adjust as needed)
  selectedImages: [], // Empty array

  genralDescription: '<p>DESCRIPTION1</p>', // Dummy description

  pricing: {
    basePrice: '2000', // Dummy price
  },
  weeklySales: 15,
  discountType: '1', // Dummy discount type (adjust as needed)
  discount_percentage: '',
  discount_fixed_price: '66', // Dummy fixed discount price

  tax: '0', // Set default tax option (adjust as needed)
  vat_amount: '22',
  sku: '2222', // User will input this
  ean: '4444', // User will input this
  advanceDescription: '<p>meta description</p>', // Dummy advance description
  weight: '',
  weightUnit: 'KGS',
  length: '',
  width: '',
  height: '',
  dimensionUnit: 'CM',
  meta_title: 'meta name', // Dummy meta title
  add_product_meta_keywords: 'meta keyword', // Matches provided data
  vendor: [],
  collection: [],
  category: null,
  inventory:[],
  custom_fields:{},
  product_custom_fields_raw: [],
  type: "",
  comparePrice: '',
  salePrice: '',
  costPrice: '',
  reorder_point_id: null,
  reorder_point_value: 1,
  isProductHasVariant: false
};  


const UpdateProduct: FC = () => {
  const handleSubmit = (values, actions) => {
    // Handle form submission here
    console.log(values)
    actions.setSubmitting(false) // Make sure to set submitting state to false after submission
  }

  return (
    <Fragment>
      <div className='d-flex flex-column flex-column-fluid'>
        <div id='kt_app_toolbar' className='app-toolbar  py-3 py-lg-6 '>
          <div
            id='kt_app_toolbar_container'
            className='app-container  container-xxl d-flex flex-stack '
          >
            <div className='page-title d-flex flex-column justify-content-center flex-wrap me-3 '>
              <h1 className='page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0'>
                Product Form
              </h1>

              <ul className='breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1'>
                <li className='breadcrumb-item text-muted'>
                  <a href='/metronic8/demo1/index.html' className='text-muted text-hover-primary'>
                    Home{' '}
                  </a>
                </li>

                <li className='breadcrumb-item'>
                  <span className='bullet bg-gray-500 w-5px h-2px'></span>
                </li>

                <li className='breadcrumb-item text-muted'>eCommerce </li>

                <li className='breadcrumb-item'>
                  <span className='bullet bg-gray-500 w-5px h-2px'></span>
                </li>

                <li className='breadcrumb-item text-muted'>Catalog </li>
              </ul>
            </div>

            <div className='d-flex align-items-center gap-2 gap-lg-3'>
              <a
                href='#'
                className='btn btn-sm fw-bold btn-primary'
                data-bs-toggle='modal'
                data-bs-target='#kt_modal_create_app'
              >
                Update{' '}
              </a>
            </div>
          </div>
        </div>

        <div >
          {/* <!--begin::Content container--> */}
          <div >
            {/*  <!--begin::Form--> */}
            <Formik initialValues={initialValues} onSubmit={handleSubmit}>
              {({ isSubmitting, handleSubmit, handleChange, values, setFormikState }) => {
                console.log("values", values)
                return (
                  <form
                    id='kt_ecommerce_add_product_form'
                    className='form d-flex flex-column flex-lg-row fv-plugins-bootstrap5 fv-plugins-framework'
                    data-kt-redirect='/metronic8/demo1/apps/ecommerce/catalog/products.html'
                    onSubmit={handleSubmit}
                  >
                    <div className='row'>
                      {/* <input  className='form-control' name='inputValue' value={values.inputValue} onChange={handleChange}/> */}
                      <div className='col-md-4 order-md-1 order-1'>
                        {/* <AsideColumn
                          values={values}
                          handleChange={handleChange}
                          setFormikState={setFormikState}
                        /> */}
                      </div>
                      <div className='col-md-8 order-md-2 order-2'>
                        {/* <MainColumn
                          values={values}
                          handleChange={handleChange}
                          setFormikState={setFormikState}
                        /> */}
                      </div>
                    </div>
                  </form>
                )
              }}
            </Formik>
            {/*  <!--end::Form--> */}
          </div>
          {/*  <!--end::Content container--> */}
        </div>
      </div>
    </Fragment>
  )
}

export default UpdateProduct


// catergory same listing plan older apis
// add new kar sakege hum category mein
// parent child chopose kar payege athen child bh create payega
// limit custom get 100
// types to be included :- all
// which field hai already default uska kya include karna hai/nahi :- yes for default all
// all needs to send with empty or has data sab custom
// infor icon for tooltip key will be description